import { Autocomplete, TextField } from '@mui/material';
import { getI18n, useTranslation } from 'react-i18next';

const LanguagePicker = () => {
  const { t } = useTranslation();
  const values = [
    {
      label: t('en'),
      value: 'en'
    },
    {
      label: t('es'),
      value: 'es'
    },
    {
      label: t('autodetect'),
      value: 'auto'
    }
  ];
  return (
    <Autocomplete
      disablePortal
      sx={{ minWidth: '150px' }}
      autoHighlight
      value={values.find((state) => state.value === getI18n().language)}
      options={values}
      onChange={(event, values) => {
        if (values) {
          if (values.value === 'auto') {
            getI18n().changeLanguage();
          } else {
            getI18n().changeLanguage(values.value);
          }
          localStorage.setItem('language', getI18n().language);
        }
      }}
      getOptionLabel={(option) => {
        return option.label;
      }}
      renderOption={(props, option) => (
        <li key={option.value} {...props}>
          {option.label}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('select_language')}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password'
          }}
        />
      )}
    />
  );
};

export default LanguagePicker;
